/* /assets/section-bbb-product.js — PDP interactions: gallery, zoom, quantity, variants */
(function () {
  function initPDP(root) {
    if (!root || root.dataset.pdpInit) return;
    root.dataset.pdpInit = '1';

    // ---- variant data ----
    var variants = [];
    var dataEl = root.querySelector('[data-product-json]');
    if (dataEl) {
      try { variants = (JSON.parse(dataEl.textContent) || {}).variants || []; } catch (e) { variants = []; }
    }

    // ---- gallery ----
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function activateMedia(id) {
      var matched = false;
      slides.forEach(function (s) {
        var on = String(s.dataset.mediaId) === String(id);
        s.classList.toggle('is-active', on);
        if (on) matched = true;
        if (!on) { var v = s.querySelector('video'); if (v && v.pause) { try { v.pause(); } catch (e) {} } }
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id));
      });
      return matched;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { activateMedia(t.dataset.mediaId); });
    });

    // ---- zoom lightbox ----
    var zoomBtn = root.querySelector('[data-zoom]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var img = root.querySelector('[data-slide].is-active img');
        if (!img) return;
        var box = document.createElement('div');
        box.className = 'bbb-pdp__lightbox is-open';
        var big = document.createElement('img');
        big.src = img.currentSrc || img.src;
        big.alt = img.alt || '';
        box.appendChild(big);
        var close = function () { box.remove(); document.removeEventListener('keydown', onKey); };
        var onKey = function (e) { if (e.key === 'Escape') close(); };
        box.addEventListener('click', close);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(box);
      });
    }

    // ---- quantity ----
    var qtyInput = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    function qtyVal() { var n = parseInt(qtyInput && qtyInput.value, 10); return isNaN(n) || n < 1 ? 1 : n; }
    if (minus && qtyInput) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, qtyVal() - 1); });
    if (plus && qtyInput) plus.addEventListener('click', function () { qtyInput.value = qtyVal() + 1; });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qtyVal(); });

    // ---- variant selection ----
    var idInput = root.querySelector('[data-variant-id]');
    var priceAmount = root.querySelector('[data-price-amount]');
    var addBtn = root.querySelector('[data-add]');
    var addText = root.querySelector('[data-add-text]');
    var optInputs = root.querySelectorAll('[data-opt-input]');

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option]').forEach(function (opt) {
        var checked = opt.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function updateVariant() {
      var opts = selectedOptions();
      var v = opts.length ? findVariant(opts) : variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceAmount) priceAmount.textContent = v.price;
      if (addBtn && addText) {
        if (v.available) {
          addBtn.disabled = false;
          addText.textContent = (addBtn.dataset.addLabel || 'Add') + ' — ' + v.price;
        } else {
          addBtn.disabled = true;
          addText.textContent = addBtn.dataset.soldout || 'Sold out';
        }
      }
      if (v.media_id) activateMedia(v.media_id);
    }
    optInputs.forEach(function (i) { i.addEventListener('change', updateVariant); });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bbb-product"]').forEach(initPDP);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector && e.target.querySelector('[data-section-type="bbb-product"]');
    if (s) initPDP(s);
  });
})();
